import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    VStack,
    HStack,
    Icon,
    Text,
    Link,
    Button,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { MdPhone, MdEmail, MdSchedule, MdHelpOutline } from 'react-icons/md';
  
  interface Props {
    isOpen: boolean;
    onClose: () => void;
  }
  
  const AyudaUsuarioModal: React.FC<Props> = ({ isOpen, onClose }) => {
    const cardBg = useColorModeValue('gray.50', 'gray.700');
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent bg={cardBg} p={4}>
          <ModalHeader>Ayuda para el Usuario</ModalHeader>
          <ModalCloseButton />
  
          <ModalBody>
            <VStack spacing={5} align="start">
              <HStack>
                <Icon as={MdPhone} boxSize={6} color="blue.500" />
                <Text>Línea de asistencia: <strong>222 111 XXXX</strong></Text>
              </HStack>
  
              <HStack>
                <Icon as={MdEmail} boxSize={6} color="green.500" />
                <Text>
                  Correo de soporte:{' '}
                  <Link color="blue.600" href="mailto:soporte@ayuntamiento.gob.mx">
                    soporte@totolac.gob.mx
                  </Link>
                </Text>
              </HStack>
  
              <HStack>
                <Icon as={MdSchedule} boxSize={6} color="orange.500" />
                <Text>Horario de atención: Lunes a Viernes, 8:00 AM - 4:00 PM</Text>
              </HStack>
  
              <HStack>
                <Icon as={MdHelpOutline} boxSize={6} color="purple.500" />
                <Text>Centro de ayuda en línea: Disponible 24/7</Text>
              </HStack>
  
              <Button
                colorScheme="blue"
                w="full"
                onClick={() => alert('Redirigir al formulario de contacto o chat')}
              >
                Contactar Soporte
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  };
  
  export default AyudaUsuarioModal;
  